/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  CompanyOptionModelCollectionDto,
  ErrorHttpContentDto,
  GetProductFeatureAccountsRequestModelDto,
  ProductFeatureAccountModelCollectionDto,
  ProductFeatureAccountParticipationsResponseDto,
  SavePositivePayCompanyConfigurationRequestModelDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class PositivePayCompanyConfigurationClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * @description Supported options: * PositivePay.ACHFilterManagement.AllowManageAchFilters : "0"/"1", indicates whether ACH Filters are enabled * PositivePay.ACHFilterManagement.ApproversRequired :0 (aka "None"), 1, 2, 3 * PositivePay.AllowIssuedItemActivityReview : "0"/"1" * PositivePay.ShowAchExceptions : "0"/"1" * PositivePay.SubstituteProductConfig.UseSubstituteProduct : "1"/"0".  Controls whether to use the substitute product.  Only present if have a substitute product installed (Centrix) * PositivePay.WorkAchExceptions : "1"/"0". * PositivePay.WorkCheckExceptions : "1"/"0". * PositivePay.CheckException.AllowReturnReason : "1"/"0". * PositivePay.CheckException.AllowCorrectionRequest : "1"/"0".
   *
   * @tags PositivePayCompanyConfiguration
   * @name PositivePayCompanyConfigurationGetAllOptions
   * @summary Retrieve all product options for a company Positive Pay product
   * @request GET:/positivePayCompanyConfiguration/{companyUniqueGuid}/allOptions
   */
  positivePayCompanyConfigurationGetAllOptions = (
    companyUniqueGuid: string,
    params: RequestParams = {},
  ) =>
    this.http.request<CompanyOptionModelCollectionDto, ErrorHttpContentDto>({
      path: `/positivePayCompanyConfiguration/${companyUniqueGuid}/allOptions`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Feature names: * ACHFilterManagement * WorkACHExceptions * WorkCheckExceptions
   *
   * @tags PositivePayCompanyConfiguration
   * @name PositivePayCompanyConfigurationGetProductFeatureAccountsGet
   * @summary Retrieve account configuration for the company Positive Pay product
   * @request GET:/positivePayCompanyConfiguration/{companyUniqueGuid}/productFeatureAccounts
   */
  positivePayCompanyConfigurationGetProductFeatureAccountsGet = (
    companyUniqueGuid: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ProductFeatureAccountModelCollectionDto,
      ErrorHttpContentDto
    >({
      path: `/positivePayCompanyConfiguration/${companyUniqueGuid}/productFeatureAccounts`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Feature names: * ACHFilterManagement * WorkACHExceptions * WorkCheckExceptions
   *
   * @tags PositivePayCompanyConfiguration
   * @name PositivePayCompanyConfigurationGetProductFeatureAccountsPost
   * @summary Retrieve account configuration for the company Positive Pay product
   * @request POST:/positivePayCompanyConfiguration/productFeatureAccounts
   */
  positivePayCompanyConfigurationGetProductFeatureAccountsPost = (
    data: GetProductFeatureAccountsRequestModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ProductFeatureAccountModelCollectionDto,
      ErrorHttpContentDto
    >({
      path: `/positivePayCompanyConfiguration/productFeatureAccounts`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description The following product options are supported for save: * PositivePay.ACHFilterManagement.AllowManageAchFilters : "0"/"1", indicates whether ACH Filters are enabled * PositivePay.ACHFilterManagement.ApproversRequired : 0 (aka "None"), 1, 2, 3 * PositivePay.AllowIssuedItemActivityReview : "0"/"1". * PositivePay.ShowAchExceptions : "0"/"1" * PositivePay.SubstituteProductConfig.UseSubstituteProduct : "1"/"0".  Controls whether to use the substitute product (if setup for and allowed by FI). * PositivePay.WorkAchExceptions : "1"/"0". * PositivePay.WorkCheckExceptions : "1"/"0". * PositivePay.CheckException.AllowReturnReason : "1"/"0". * PositivePay.CheckException.AllowCorrectionRequest : "1"/"0". For product account feature participations, the following features (feature names) are supported : * ACHFilterManagement * WorkAchExceptions * WorkCheckExceptions For account feature participations: * Participations should only be passed if company configuration allows.  Setting a company option which disallows participations will result in HTTP 400. Example : saving option PositivePay.ACHFilterManagement.AllowManageAchFilters = "0" means should not pass participations for ACHFilterManagement. * If no accounts are selected : should submit entry with feature name but no accounts OR having all participation flags set to false. * Only the AccountId has to be set to identify the participating account.  Setting the other account properties like CifNumber is unnecessary as those will be ignored for save. * Not submitting an account for participation (when account is already participating) will be handled as if the account were passed with participation flag off.
   *
   * @tags PositivePayCompanyConfiguration
   * @name PositivePayCompanyConfigurationSaveProductConfiguration
   * @summary Saves product configuration for company Positive Pay product
   * @request POST:/positivePayCompanyConfiguration/{companyUniqueGuid}
   */
  positivePayCompanyConfigurationSaveProductConfiguration = (
    companyUniqueGuid: string,
    data: SavePositivePayCompanyConfigurationRequestModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, ErrorHttpContentDto>({
      path: `/positivePayCompanyConfiguration/${companyUniqueGuid}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description The following product options are supported for save: * PositivePay.ACHFilterManagement.AllowManageAchFilters : "0"/"1", indicates whether ACH Filters are enabled * PositivePay.ACHFilterManagement.ApproversRequired : 0 (aka "None"), 1, 2, 3 * PositivePay.AllowIssuedItemActivityReview : "0"/"1". * PositivePay.ShowAchExceptions : "0"/"1" * PositivePay.SubstituteProductConfig.UseSubstituteProduct : "1"/"0".  Controls whether to use the substitute product (if setup for and allowed by FI). * PositivePay.WorkAchExceptions : "1"/"0". * PositivePay.WorkCheckExceptions : "1"/"0". * PositivePay.CheckException.AllowReturnReason : "1"/"0". * PositivePay.CheckException.AllowCorrectionRequest : "1"/"0". For product account feature participations, the following features (feature names) are supported : * ACHFilterManagement * WorkAchExceptions * WorkCheckExceptions For account feature participations: * Participations should only be passed if company configuration allows.  Setting a company option which disallows participations will result in HTTP 400. Example : saving option PositivePay.ACHFilterManagement.AllowManageAchFilters = "0" means should not pass participations for ACHFilterManagement. * If no accounts are selected : should submit entry with feature name but no accounts OR having all participation flags set to false. * Only the AccountId has to be set to identify the participating account.  Setting the other account properties like CifNumber is unnecessary as those will be ignored for save. * Not submitting an account for participation (when account is already participating) will be handled as if the account were passed with participation flag off.
   *
   * @tags PositivePayCompanyConfiguration
   * @name PositivePayCompanyConfigurationSaveProductConfigurationAsJson
   * @summary Saves product configuration for company Positive Pay product
   * @request POST:/positivePayCompanyConfiguration/{companyUniqueGuid}/configurationAsJson
   */
  positivePayCompanyConfigurationSaveProductConfigurationAsJson = (
    companyUniqueGuid: string,
    data: string,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, ErrorHttpContentDto>({
      path: `/positivePayCompanyConfiguration/${companyUniqueGuid}/configurationAsJson`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PositivePayCompanyConfiguration
   * @name PositivePayCompanyConfigurationGetAchExceptionAccounts
   * @summary Gets a collection of product feature accounts for ACH exception by company unique GUID.
   * @request GET:/positivePayCompanyConfiguration/{companyUniqueGuid}/achExceptionAccounts
   */
  positivePayCompanyConfigurationGetAchExceptionAccounts = (
    companyUniqueGuid: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ProductFeatureAccountParticipationsResponseDto,
      ErrorHttpContentDto
    >({
      path: `/positivePayCompanyConfiguration/${companyUniqueGuid}/achExceptionAccounts`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PositivePayCompanyConfiguration
   * @name PositivePayCompanyConfigurationGetCheckExceptionAccounts
   * @summary Gets a collection of product feature accounts for check exception by company unique GUID.
   * @request GET:/positivePayCompanyConfiguration/{companyUniqueGuid}/checkExceptionAccounts
   */
  positivePayCompanyConfigurationGetCheckExceptionAccounts = (
    companyUniqueGuid: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ProductFeatureAccountParticipationsResponseDto,
      ErrorHttpContentDto
    >({
      path: `/positivePayCompanyConfiguration/${companyUniqueGuid}/checkExceptionAccounts`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PositivePayCompanyConfiguration
   * @name PositivePayCompanyConfigurationGetAchFilterManagementAccounts
   * @summary Gets a collection of product feature accounts for ACH Filter Management by company unique ID.
   * @request GET:/positivePayCompanyConfiguration/{companyUniqueGuid}/achFilterManagementAccounts
   */
  positivePayCompanyConfigurationGetAchFilterManagementAccounts = (
    companyUniqueGuid: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ProductFeatureAccountModelCollectionDto,
      ErrorHttpContentDto
    >({
      path: `/positivePayCompanyConfiguration/${companyUniqueGuid}/achFilterManagementAccounts`,
      method: "GET",
      format: "json",
      ...params,
    });
}
